export default {
  reason:
    "You are not setup as an authorized user in the prescription management system.  Please talk to your system administrator.",
  close: "Close this window",
};
